import {
  Modal,
  ModalOverlay,
  ModalContent,
  useBreakpointValue,
  Button,
  Icon,
  ModalCloseButton,
  ButtonProps,
} from '@chakra-ui/react';
import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LockIconOpen from '@/assets/icons/ic-lock-open.svg';

import { EpisodePremiumOverlayMobile } from '@/components/ui/features/originals/EpisodesSection/components/EpisodePremiumOverlayMobile';

export const LecturePremiumOverlayButton: FC<ButtonProps> = (buttonProps) => {
  const isCentered = useBreakpointValue({ base: false, md: true });
  const { t } = useTranslation();
  const [isOpenModal, setOpenModal] = useState(false);

  return (
    <Fragment>
      <Button
        rightIcon={<Icon as={LockIconOpen} h="1.5rem" w="1.5rem" color="white" />}
        as="button"
        variant="solid"
        onClick={() => setOpenModal(true)}
        size="lg"
        {...buttonProps}
      >
        {t('premiumContentFallback.accessPremiumContent')}
      </Button>
      <Modal isOpen={isOpenModal} onClose={() => setOpenModal(false)} isCentered={isCentered}>
        <ModalOverlay />
        <ModalContent maxW="full" bgColor="rgba(255,255,255,0)">
          <EpisodePremiumOverlayMobile />
          <ModalCloseButton color="white" />
        </ModalContent>
      </Modal>
    </Fragment>
  );
};
